import React, { useMemo } from 'react'
import { motion } from 'framer-motion'
import './AnimatedBackground.css'

const AnimatedBackground = () => {
  // Memoize particle positions to prevent recalculation on re-renders
  const particlePositions = useMemo(() => {
    return [...Array(8)].map((_, i) => ({
      left: `${(i * 12.5) % 100}%`,
      top: `${((i * 17) % 100)}%`,
      delay: i * 0.3,
      duration: 4 + (i % 3)
    }))
  }, [])

  return (
    <div className="animated-background">
      {/* Gradient Orbs - using CSS animations for better performance */}
      <div className="bg-orb orb-1" />
      <div className="bg-orb orb-2" />
      <div className="bg-orb orb-3" />

      {/* Grid Pattern */}
      <div className="bg-grid" />

      {/* Floating Particles - reduced from 20 to 8, using CSS animations */}
      {particlePositions.map((pos, i) => (
        <div
          key={i}
          className="bg-particle"
          style={{
            left: pos.left,
            top: pos.top,
            animationDelay: `${pos.delay}s`,
            animationDuration: `${pos.duration}s`
          }}
        />
      ))}

      {/* Code Snippets Decoration */}
      <div className="code-decoration code-1">
        <span>{'const portfolio = {'}</span>
        <span>{'  developer: "Onyema",'}</span>
        <span>{'  role: "Full Stack"'}</span>
        <span>{'};'}</span>
      </div>
      <div className="code-decoration code-2">
        <span>{'function createAwesome() {'}</span>
        <span>{'  return magic;'}</span>
        <span>{'}'}</span>
      </div>
      <div className="code-decoration code-3">
        <span>{'<Developer'}</span>
        <span>{'  skills={["React", "Node"]}'}</span>
        <span>{'  passion={true}'}</span>
        <span>{'/>'}</span>
      </div>
    </div>
  )
}

export default AnimatedBackground
